import { render, staticRenderFns } from "./liveRoom.vue?vue&type=template&id=4d7c1312&scoped=true&"
import script from "./liveRoom.vue?vue&type=script&lang=js&"
export * from "./liveRoom.vue?vue&type=script&lang=js&"
import style0 from "./liveRoom.vue?vue&type=style&index=0&id=4d7c1312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c1312",
  null
  
)

export default component.exports